/**
 * Resolve a workspace-relative path into the Host-facing spelling used by openPath.
 * @param cwd - session workspace root, when known.
 * @param path - absolute or workspace-relative path.
 * @returns an absolute path when a workspace root is available, otherwise the original path.
 */
export function resolveWorkspacePath(cwd, path) {
    if (path.startsWith('/') || isWindowsStylePath(path))
        return path;
    if (cwd === undefined || cwd === '')
        return path;
    const base = cwd.replace(/[/\\]+$/, '');
    const rel = path.replace(/^[/\\]+/, '');
    return `${base}/${rel}`;
}
/** Drive-letter or UNC path; Web display must not rewrite these as `~`. */
function isWindowsStylePath(value) {
    return /^[A-Za-z]:[/\\]/.test(value) || value.startsWith('\\\\');
}
/**
 * Display-only POSIX home abbreviation. Windows drive and UNC paths stay
 * verbatim, including when `home` itself is a Windows path. A missing, empty,
 * or filesystem-root `home` leaves `path` unchanged so `/` cannot become `~`.
 * @param path - absolute or already-short display path.
 * @param home - host account home from `host.describe`; absent skips abbreviation.
 * @returns `~` or `~/…` for the POSIX home and its descendants, otherwise `path`.
 */
export function abbreviateHomePath(path, home) {
    if (home === undefined || home === '')
        return path;
    if (isWindowsStylePath(path) || isWindowsStylePath(home))
        return path;
    const root = home.replace(/\/+$/, '');
    if (root === '' || root === '/')
        return path;
    if (path.replace(/\/+$/, '') === root)
        return '~';
    if (path.startsWith(`${root}/`))
        return `~${path.slice(root.length)}`;
    return path;
}
//# sourceMappingURL=path.js.map